import { SUBSCRIPTION_PLANS } from '@src/constants';
import { CustomerCalculatedSubscriptionStateEnum } from '@src/graphql/generated';

export const canActivateFreemium = (_recruiter, planInfo, planType) => {
  return (
    planType === SUBSCRIPTION_PLANS.FREEMIUM.toLowerCase() &&
    planInfo.state === CustomerCalculatedSubscriptionStateEnum.SUBSCRIPTION_ACTIVE
  );
};
